import { createGlobalState } from "react-hooks-global-state";
import { defaultBroadCategories } from "./utils/constants";
import { bootListState, registerListStateProvider } from "./utils/listState";
import _ from "lodash";

export const defaultUser = { id: null, credits: 0 };

const initialState = {
  user: defaultUser,
  trips: [],
  // Pages that draw their own chrome (club event page) hide the global header.
  hideHeader: false,
  // Header over a page's own background (club event pages): false | "clear"
  // (at the top: no bar at all) | "frosted" (scrolled: frosted white).
  headerTranslucent: false,
  userLoading: true,
  // True when the boot-time getUser() fetch failed for a NON-401 reason (a
  // transient backend/network blip) while a JWT is still present — i.e. the
  // user is really logged in but we couldn't hydrate them. Gates the checkout
  // login step so we never show "log in to reserve" to a token-holder.
  userFetchError: false,
  showProfile: false,
  openGroupDetails: false,
  openLogin: false,
  welcomePromoEligible: null,
  openAlertBannerMsg: "",
  // A cold back to /all-trips brings back its list (utils/listState.js).
  sortByHome: bootListState?.sortByHome ?? "dates",
  promotion: null,
  searchedTrips: bootListState?.searchedTrips ?? [],
  quickSearch: false,
  resetDisplaySearch: false,
  searchMobile: false,
  prevSearchMonths: "",
  prevSearchDestination: "",
  projectCountData: {},
  searchPageNum: bootListState?.searchPageNum ?? {},
  showBroadCategories: defaultBroadCategories,
  conciergeOpen: false,
  activeLuckyDrawCampaign: undefined,
  openLuckyDrawGame: false,

  // Locale-related state
  language: "en",
  community: "sg",
  currency: "sgd",
  localeLoading: true,

  translations: Object.fromEntries(
    [
      "projects",
      "activities",
      "promotions",
      "highlights",
      "tripReviews",
      "projectItineraryHighlights",
      "projectDailyItineraries",
    ].map((resource) => [resource, {}])
  ),
};

export const { useGlobalState, getGlobalState } = createGlobalState(initialState);

registerListStateProvider(() => ({
  sortByHome: getGlobalState("sortByHome"),
  searchedTrips: getGlobalState("searchedTrips"),
  searchPageNum: getGlobalState("searchPageNum"),
}));

// Helper function to update translations
export const updateTranslations = (setTranslations, resource, language, data) => {
  const newTranslationsState = {
    currentLanguage: language,
    resources: {
      ...initialState.translations.resources,
      [resource]: data,
    },
  };

  setTranslations(newTranslationsState);
};

export function isLoggedIn(user) {
  return !_.isEqual(user, defaultUser);
}
